'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _dec, _class, _class2, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactRedux = require('react-redux');

var _components = require('../../components');

var _DefaultString = require('../../helpers/DefaultString');

var _auth = require('../../redux/modules/auth');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LogoutButton = (_dec = (0, _reactRedux.connect)(function (state) {
  return { auth: state.auth };
}, { logout: _auth.logout }), _dec(_class = (_temp2 = _class2 = function (_Component) {
  (0, _inherits3.default)(LogoutButton, _Component);

  function LogoutButton() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, LogoutButton);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = LogoutButton.__proto__ || (0, _getPrototypeOf2.default)(LogoutButton)).call.apply(_ref, [this].concat(args))), _this), _this.onLogout = function () {
      _this.props.logout();
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(LogoutButton, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(_components.BaseButton, { className: this.props.className, onClick: this.onLogout, buttonString: _DefaultString.translations.LogoutText });
    }
  }]);
  return LogoutButton;
}(_react.Component), _class2.propTypes = {
  className: _react.PropTypes.string,
  logout: _react.PropTypes.func.isRequired
}, _temp2)) || _class);
exports.default = LogoutButton;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/LogoutButton/LogoutButton.js
// module id = 1959
// module chunks = 0